var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "slider-wrapper w-100",
      attrs: { id: "ci-scroll-snap-slider" },
    },
    [
      _c(
        "div",
        { ref: "scrollSnapSlider", staticClass: "slider d-flex" },
        [
          _vm._l(_vm.items, function (item, index) {
            return _vm.items && _vm.itemsLength > 0
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "observe-visibility",
                        rawName: "v-observe-visibility",
                        value: _vm.itemObserver(index),
                        expression: "itemObserver(index)",
                      },
                    ],
                    key: index,
                    staticClass: "slide d-inline-flex",
                    class: _vm.handleCssClassForItemWidth,
                  },
                  [_vm._t("default", null, { item: item, index: index })],
                  2
                )
              : _vm._e()
          }),
          _vm.optionalItem
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "observe-visibility",
                      rawName: "v-observe-visibility",
                      value: _vm.itemObserver(_vm.itemsLength - 1),
                      expression: "itemObserver(itemsLength - 1)",
                    },
                  ],
                  staticClass: "slide d-inline-flex",
                  class: _vm.handleCssClassForItemWidth,
                },
                [_vm._t("optionalItem")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.handleNavigationOnViewPort
        ? _c(
            "div",
            {
              staticClass: "botton-navigation d-flex w-100",
              class: _vm.prevNextButtonOnVisibilityPosition,
            },
            [
              _vm.prevVisible
                ? _c("ci-button", {
                    staticClass: "prev d-inline-flex align-items-center",
                    attrs: {
                      variant: "filled-primary",
                      fab: "true",
                      icon: "mdi-chevron-left",
                      "icon-class": "mdi-36px",
                      size: "xs",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.scrollSlider(-1)
                      },
                    },
                  })
                : _vm._e(),
              _vm.nextVisible
                ? _c("ci-button", {
                    staticClass:
                      "next d-inline-flex align-items-center justify-content-end",
                    attrs: {
                      variant: "filled-primary",
                      fab: "true",
                      icon: "mdi-chevron-right",
                      "icon-class": "mdi-36px",
                      size: "xs",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.scrollSlider(1)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.slider && _vm.mobileMode && _vm.displayIndicators
        ? _c(
            "div",
            {
              staticClass: "slide-indicator d-flex justify-content-center mt-3",
            },
            _vm._l(_vm.slider.children, function (item, index) {
              return _c("span", {
                key: `indicator-${index}`,
                staticClass: "indicator mx-2",
                class: { active: _vm.activeIndicator(index) },
                on: {
                  click: function ($event) {
                    return _vm.scrollSlider(index)
                  },
                },
              })
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }